<app-modal
  [(visible)]="visible"
  (visibleChange)="visibleChange.emit($event)"
  (onShowing)="onShowingInternal()"
  (onHidden)="onHiddenInternal()"
  [closeOutsideClickEnabled]="false"
  modalTitle="Elemento de caraterização"
  width="25rem"
  height="35rem"
  maxHeight="42.8rem"
>
  <ng-template modalContent>
    <form class="form" [formGroup]="formGroup" (ngSubmit)="onSubmit($event)">
      <app-scroll-view class="scroll-view">
        <div class="fields-container">
          <div class="field-set">
            <label label>{{ "baseinstalacao" | fieldAlias: fields }}</label>

            <app-select-box
              formControlName="baseinstalacao"
              [items]="getFieldDomain('baseinstalacao')"
              displayExpr="name"
              valueExpr="code"
              [searchEnabled]="true"
              [searchCaseSensitiveEnabled]="false"
              [showErrorEnabled]="false"
            ></app-select-box>
          </div>

          <div class="field-set">
            <label label>{{ "tracado" | fieldAlias: fields }}</label>

            <app-select-box
              formControlName="tracado"
              [items]="getFieldDomain('tracado')"
              displayExpr="name"
              valueExpr="code"
              [searchEnabled]="true"
              [searchCaseSensitiveEnabled]="false"
              [showErrorEnabled]="false"
            ></app-select-box>
          </div>

          <div class="field-set">
            <label label>{{ "afetacaoprincipal" | fieldAlias: fields }}</label>

            <app-select-box
              formControlName="afetacaoprincipal"
              [items]="getFieldDomain('afetacaoprincipal')"
              displayExpr="name"
              valueExpr="code"
              [searchEnabled]="true"
              [searchCaseSensitiveEnabled]="false"
              [showErrorEnabled]="false"
            ></app-select-box>
          </div>

          <div class="field-set">
            <label label>{{ "diametro" | fieldAlias: fields }}</label>

            <div class="input-value-with-operator" formGroupName="diametro">
              <app-select-box
                class="input-operator"
                formControlName="operator"
                [items]="operatorList"
                displayExpr="label"
                valueExpr="value"
                [showClearButton]="false"
                [showErrorEnabled]="false"
              ></app-select-box>

              <app-input-box
                class="input"
                type="number"
                formControlName="value"
                [showClearButton]="false"
                [showErrorEnabled]="false"
              ></app-input-box>
            </div>
          </div>

          <div class="field-set">
            <label label>{{ "comprimento" | fieldAlias: fields }}</label>

            <div class="input-value-with-operator" formGroupName="comprimento">
              <app-select-box
                class="input-operator"
                formControlName="operator"
                [items]="operatorList"
                displayExpr="label"
                valueExpr="value"
                [showClearButton]="false"
                [showErrorEnabled]="false"
              ></app-select-box>

              <app-input-box
                class="input"
                type="number"
                formControlName="value"
                [showClearButton]="false"
                [showErrorEnabled]="false"
              ></app-input-box>
            </div>
          </div>

          <div class="field-set">
            <label label>{{ "largura" | fieldAlias: fields }}</label>

            <div class="input-value-with-operator" formGroupName="largura">
              <app-select-box
                class="input-operator"
                formControlName="operator"
                [items]="operatorList"
                displayExpr="label"
                valueExpr="value"
                [showClearButton]="false"
                [showErrorEnabled]="false"
              ></app-select-box>

              <app-input-box
                class="input"
                type="number"
                formControlName="value"
                [showClearButton]="false"
                [showErrorEnabled]="false"
              ></app-input-box>
            </div>
          </div>

          <div class="field-set">
            <label label>{{ "altura" | fieldAlias: fields }}</label>

            <div class="input-value-with-operator" formGroupName="altura">
              <app-select-box
                class="input-operator"
                formControlName="operator"
                [items]="operatorList"
                displayExpr="label"
                valueExpr="value"
                [showClearButton]="false"
                [showErrorEnabled]="false"
              ></app-select-box>

              <app-input-box
                class="input"
                type="number"
                formControlName="value"
                [showClearButton]="false"
                [showErrorEnabled]="false"
              ></app-input-box>
            </div>
          </div>

          <div class="field-set">
            <label label>{{ "cota" | fieldAlias: fields }}</label>

            <div class="input-value-with-operator" formGroupName="cota">
              <app-select-box
                class="input-operator"
                formControlName="operator"
                [items]="operatorList"
                displayExpr="label"
                valueExpr="value"
                [showClearButton]="false"
                [showErrorEnabled]="false"
              ></app-select-box>

              <app-input-box
                class="input"
                type="number"
                formControlName="value"
                [showClearButton]="false"
                [showErrorEnabled]="false"
              ></app-input-box>
            </div>
          </div>

          <div class="field-set">
            <label label>{{ "tipoutilizacao" | fieldAlias: fields }}</label>

            <app-type-utilization-box
              formControlName="tipoutilizacao"
            ></app-type-utilization-box>
          </div>

          <div class="field-set">
            <label label>{{ "estadooperacional" | fieldAlias: fields }}</label>

            <app-select-box
              formControlName="estadooperacional"
              [items]="getFieldDomain('estadooperacional')"
              displayExpr="name"
              valueExpr="code"
              [searchEnabled]="true"
              [searchCaseSensitiveEnabled]="false"
              [showErrorEnabled]="false"
            ></app-select-box>
          </div>

          <div class="field-set">
            <label label>{{ "estadoocupacao" | fieldAlias: fields }}</label>

            <div
              class="input-value-with-operator"
              formGroupName="estadoocupacao"
            >
              <app-select-box
                class="input-operator"
                formControlName="operator"
                [items]="operatorList"
                displayExpr="label"
                valueExpr="value"
                [showClearButton]="false"
                [showErrorEnabled]="false"
              ></app-select-box>

              <app-input-box
                class="input"
                type="number"
                formControlName="value"
                [showClearButton]="false"
                [showErrorEnabled]="false"
              ></app-input-box>
            </div>
          </div>

          <div class="field-set">
            <label label>{{ "created_date" | fieldAlias: fields }}</label>

            <app-date-box
              formControlName="created_date"
              type="datetime"
              [showErrorEnabled]="false"
            ></app-date-box>
          </div>
        </div>
      </app-scroll-view>

      <div class="actions-bottom">
        <app-button
          type="submit"
          buttonType="primary"
          styleType="contained"
          text="Aplicar"
          width="100%"
        ></app-button>

        <app-button
          buttonType="normal"
          styleType="contained"
          text="Limpar"
          (click)="onBtnClearClick()"
          width="100%"
        ></app-button>
      </div>
    </form>
  </ng-template>
</app-modal>
